import React from 'react';

interface Props {
  // Dirección meteorológica: de dónde VIENE el viento (0 = norte).
  direction: number | null;
  speed?: number | null;
  size?: number;
  showLabels?: boolean;
}

// La flecha apunta hacia donde sopla el viento (dirección + 180°), como en
// las apps de clima: un viento "del sudoeste" se dibuja yendo hacia el noreste.
const WindCompass: React.FC<Props> = ({ direction, speed, size = 64, showLabels = true }) => {
  const c = 50;
  const ticks = Array.from({ length: 16 }, (_, i) => i * 22.5);
  return (
    <svg viewBox="0 0 100 100" width={size} height={size} className="wind-compass" role="img" aria-label="Brújula de viento">
      <circle cx={c} cy={c} r={46} className="wind-compass-ring" />
      {ticks.map((deg) => {
        const major = deg % 90 === 0;
        const rad = (deg * Math.PI) / 180;
        const r1 = major ? 37 : 40;
        return (
          <line
            key={deg}
            x1={c + Math.sin(rad) * r1}
            y1={c - Math.cos(rad) * r1}
            x2={c + Math.sin(rad) * 44}
            y2={c - Math.cos(rad) * 44}
            className={major ? 'wind-compass-tick major' : 'wind-compass-tick'}
          />
        );
      })}
      {showLabels &&
        [
          ['N', 0],
          ['E', 90],
          ['S', 180],
          ['O', 270],
        ].map(([label, deg]) => {
          const rad = ((deg as number) * Math.PI) / 180;
          return (
            <text
              key={label}
              x={c + Math.sin(rad) * 28}
              y={c - Math.cos(rad) * 28 + 4}
              textAnchor="middle"
              className={label === 'N' ? 'wind-compass-label north' : 'wind-compass-label'}
            >
              {label}
            </text>
          );
        })}
      {direction !== null && (
        <g transform={`rotate(${direction + 180} ${c} ${c})`} className="wind-compass-arrow">
          <line x1={c} y1={c + 30} x2={c} y2={c - 26} />
          <path d={`M ${c} ${c - 36} L ${c - 8} ${c - 20} L ${c + 8} ${c - 20} Z`} />
        </g>
      )}
      {speed !== undefined && speed !== null && !showLabels && (
        <text x={c} y={c + 5} textAnchor="middle" className="wind-compass-speed">
          {Math.round(speed)}
        </text>
      )}
    </svg>
  );
};

export default WindCompass;
